import React, { useState, createContext, useContext } from "react";

const TabsContext = createContext();


export const Tabs = ({ defaultValue, onValueChange, children, className }) => {

  const [activeTab, setActiveTab] = useState(defaultValue);

  const handleTabChange = (value) => {
    setActiveTab(value);
    if (onValueChange) {
      onValueChange(value);
    }
  };

  return (
    <TabsContext.Provider value={{ activeTab, setActiveTab: handleTabChange }}>
      <div className={className ? className : ""}>{children}</div>
    </TabsContext.Provider>
  );
};


export const TabsList = ({ children, className }) => (
  <div className={className ? className : "tabs-list dark:bg-[#2c3440] dark:text-white"}>{children}</div>
);

export const TabsTrigger = ({ value, children, className, disabled }) => {

  const { activeTab, setActiveTab } = useContext(TabsContext);
  const isActive = activeTab === value;

  return (
    <button
      disabled={disabled}
      className={ className ? className : `tab-trigger ${isActive ? "active dark:bg-[#2c3440] dark:text-white" : "dark:text-white"}`}
      onClick={() => {
        if (disabled) return;
        setActiveTab(value);
      }}
    >
      {children}
    </button>
  );
};


export const TabsContent = ({ value, children, className="" }) => {
  const { activeTab } = useContext(TabsContext);
  return activeTab === value ? <div className={className ? className :"tabs-content"}>{children}</div> : null;
};